// Mirrors the response shape of coaching's
// GET /api/public/profile/:username/coaching-signals.
// Kept in a non-`.server` module so both the server loader/client and the
// client-rendered card can import it.

export interface CoachingSignals {
  isCoach: boolean;
  sessionsDelivered: number;
}

export function hasCoachingSignal(
  signals: CoachingSignals | null | undefined,
): signals is CoachingSignals {
  return Boolean(signals?.isCoach);
}
